/* Edits the state whenever siteId is changed */

export default function siteId(state = [], action) {
	switch (action.type) {
	case 'SITEID_CHANGED' :
		return action.siteId;

	default:
		return state;
	}
}
